import React, { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import {
  toCompactNumber,
  formatToCommaString,
  numDifferentiation,
} from "../helper/format";

function RenderCustomizedLabel(props) {
  const { x, y, index, chartData, labelProperty } = props;

  const label = chartData[index][labelProperty];

  return (
    <>
      <text
        x={x - 2}
        y={y}
        dy={-8}
        fill="rgba(199, 199, 199, 1)"
        textAnchor="start"
        fontSize={11}
      >
        {numDifferentiation(label, 1)}
      </text>
    </>
  );
}

const CustomTooltip = ({ active, payload, label, labelProperty }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          background: "rgba(255,255,255,0.56)",
          borderRadius: 12,
          padding: 16,
        }}
      >
        <p
          style={{
            margin: 8,
            fontSize: 12,
            fontWeight: 500,
          }}
        >{`Day - ${label}`}</p>
        <p
          style={{
            margin: 8,
            fontSize: 14,
            fontWeight: 600,
          }}
        >{`${labelProperty ?? "Acquisition Count"} - ${formatToCommaString(
          payload[0].value
        )}`}</p>
      </div>
    );
  }

  return null;
};

export default function ResponsiveBarChart({ data, labelY, labelX }) {
  const [focusBar, setFocusBar] = useState(null);

  const onMouseMove = (_, index) => {
    setFocusBar(index);
  };

  return (
    <ResponsiveContainer width="99%" height="100%">
      <BarChart
        height={300}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis axisLine={false} tickLine={false} dataKey={labelX ?? "Day"} />
        <YAxis
          axisLine={false}
          tickLine={false}
          tickFormatter={toCompactNumber}
          dataKey={labelY ?? "Acquisition"}
          // domain={[0, maximumValue + 10000]}
        />
        <Tooltip
          content={<CustomTooltip labelProperty={labelY ?? "Acquisition"} />}
          cursor={false}
        />
        <Bar
          dataKey={labelY ?? "Acquisition"}
          fill="rgba(199, 199, 199, 1)"
          label={
            <RenderCustomizedLabel
              chartData={data}
              labelProperty={labelY ?? "Acquisition"}
            />
          }
          //barSize={30}
          onMouseEnter={onMouseMove}
          activeIndex={focusBar}
        >
          {data.map((entry, index) => (
            <Cell
              key={entry.name}
              fill={
                focusBar === index
                  ? "rgba(226, 19, 110, 1)"
                  : "rgba(199, 199, 199, 1)"
              }
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
